import pairingErrors from '../../consts/device/pairingErrors';

export default class GetPermittedBuetoothDeviceError extends Error {
    constructor(message = '', ...args) {
        super(message, ...args);
        this.message = 'getPermittedBluetoothDevices timeout error';
        this.code = pairingErrors.ERROR_CONNECTION_NOT_FOUND.type;
    }
}
